<div class="dialog-viewer">
    <h2 mat-dialog-title>Edit Price</h2>

    <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-dialog-content>
            <div class="row">
                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            </div>
            <div class="container-fluid">
                <div class="row mb-3">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Simulator</mat-label>
                            <mat-select formControlName="simulatorId" required>
                                <mat-option *ngFor="let simulator of simulators" 
                                          [value]="simulator.id">
                                    {{simulator.bayName}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('simulatorId').errors?.required">
                                Simulator is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Price Band</mat-label>
                            <mat-select formControlName="priceBandId" required>
                                <mat-option *ngFor="let band of priceBands" 
                                          [value]="band.id">
                                    {{band.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('priceBandId').errors?.required">
                                Price Band is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Amount</mat-label>
                            <input matInput type="number" formControlName="amount" required>
                            <span matPrefix>$ &nbsp;</span>
                            <mat-error *ngIf="form.get('amount').errors?.required">
                                Amount is required
                            </mat-error>
                            <mat-error *ngIf="form.get('amount').errors?.min">
                                Amount must be greater than 0
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Duration</mat-label>
                            <mat-select formControlName="durationMinutes" required>
                                <mat-option *ngFor="let duration of availableBookingDurations" [value]="duration.durationMinutes">{{duration.durationMinutes | minutesToHours}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-error *ngIf="form.get('durationMinutes').errors?.required">
                            Duration is required
                        </mat-error>
                        <mat-error *ngIf="form.get('durationMinutes').errors?.min">
                            Duration must be greater than 0
                        </mat-error>
                    </div>
                </div>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions>
            <button mat-raised-button type="submit" 
                    [disabled]="!form.valid || isLoading">Save</button>
            <button mat-raised-button type="button" class="warning" 
                    [disabled]="isLoading" 
                    (click)="dialogRef.close('cancel')">Cancel</button>
        </mat-dialog-actions>
    </form>
</div>
